// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2UfKu","inputWrap":"styles_inputWrap__YArn3","input":"styles_input__1tJze"};